<template>
    <Modal v-if="modals.generatePoster && grimoire.generatePosterImage != ''" @close="close">
        <div class="GeneratePoster">
            <img :src="grimoire.generatePosterImage" />
            <p>长按图片保存</p>
        </div>
    </Modal>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import Modal from "./Modal";
export default {
    name: "GeneratePoster",
    components: { Modal },
    computed: {
        ...mapState(["grimoire", "modals"]),
    },
    methods: {
        close() {
            this.toggleModal("generatePoster");
            this.$store.commit("setGeneratePosterImage", "");
        },
        ...mapMutations(["toggleModal"])
    }
};
</script>
<style lang="scss" scoped>
    .GeneratePoster{
        width: 80%;
        margin: 0 auto;
        img{
            display: block;
            width: 100%;
        }
        p{
            text-align: center;
        }
    }
</style>
